/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ subject: NonNullable<unknown> }} Rights_Remove_Subject_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "This removes every capability override for {subject}. They fall back to the organization defaults." |
*
* @param {Rights_Remove_Subject_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_remove_subject_confirm_description = /** @type {((inputs: Rights_Remove_Subject_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Remove_Subject_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Entfernt alle Berechtigungs-Ausnahmen für ${i?.subject}. Es gelten wieder die Organisations-Standards.`)
	return /** @type {LocalizedString} */ (`This removes every capability override for ${i?.subject}. They fall back to the organization defaults.`)
});